export default __webpack_public_path__ + "static/media/automovelMobileDetails.f54b44c4.png";